<template>
  <tml-new-popup
    name="youtube-help-video"
    layout="standard"
    size="wide"
    height="auto"
    title="Design your first product"
  >
    <template #content>
      <tml-youtube-video video-id="-n7eciE0ISs" autoplay />
      <div v-if="shouldShowDesignBlogs">
        <h4 class="mt-4 mb-1">
          Read More: Design Blogs
        </h4>
        <tml-carousel
          :breakpoints="{
            xs: 2,
            md: 3,
            lg: 4,
          }"
          :spacing="8"
          :overlap="32"
          :ratio="3 / 4"
          class="mb-0"
        >
          <template v-for="blog in blogs" :key="blog.id">
            <tml-new-pod
              :title="blog.title"
              :image="formatUrl(blog.metaImage.thumbnail)"
              :ratio="3 / 4"
              no-default-wedge
              @click="openNewTab(blog.url)"
            />
          </template>
        </tml-carousel>
      </div>
      <h4 class="mt-4 mb-1">
        Help &amp; Support
      </h4>
      <div class="pt-4">
        <tml-grid
          :breakpoints="{
            xs: 2,
            md: 4,
            lg: 4,
          }"
          spacing="1em"
        >
          <tml-new-pod
            title="Get instant answers in the design FAQs"
            :image="FaqIconHelpPage"
            @click="openNewTab('/store-help/')"
          />
          <tml-new-pod
            title="Pro: Join the design chat, hosted by @cpadz."
            :image="ChatIconHelpPage"
            :class="{
              'unlock-with-pro':
                !$project.active?.isPro &&
                $project.active?.hasIntegration('website'),
            }"
            @click="openDesignChat()"
          />
        </tml-grid>
      </div>
    </template>
  </tml-new-popup>
</template>

<script>
import {formatUrl} from '@teemill/common/helpers';
import {openUpgradePopup, chatsBanner} from '@teemill/modules/pro';

import FaqIconHelpPage from '../../assets/img/faq_icon_help_page.jpg';
import ChatIconHelpPage from '../../assets/img/chat_icon_help_page.jpg';

export default {
  name: 'StudioHelpPopup',

  inject: ['app'],

  props: {
    isApproved: Boolean,
    default: false,
  },

  data() {
    return {
      blogs: [],

      FaqIconHelpPage,
      ChatIconHelpPage,
    };
  },

  computed: {
    shouldShowDesignBlogs() {
      return this.isApproved && this.blogs?.length;
    },
  },

  created() {
    this.axios
      .get(formatUrl('/omnis/v3/blog/tag/'), {
        params: {
          blogTag: 'design',
          divisions: 12,
        },
      })
      .success(({posts}) => {
        this.blogs = posts;
      })
      .catch();
  },

  methods: {
    formatUrl,

    openNewTab(url) {
      window.open(url, '_blank', 'noopener, noreferrer');
    },

    openDesignChat() {
      if (
        !this.$project.active?.isPro &&
        this.$project.active?.hasIntegration('website')
      ) {
        return openUpgradePopup({
          origin: 'studio-help-popup-design-chat',
          title: 'Access the Pro community',
          description:
            'Upgrade to Teemill Pro and chat with our community of Teemill experts and other successful brand owners.',
          image: chatsBanner,
        });
      }

      this.openNewTab('/chat/design/');
    },
  },
};
</script>
